<template>
  <div class="container-fluid p-0">
    <Card>
      <template slot="header">
        <h4>وضعیت تــیکت هـــای من</h4>
        <hr />
      </template>
      <template slot="btnCustome">
        <span class=""><i class="fas fa-eye font-weight-bold hover-danger float-left my-2 Pointer" @click="AllTicket()" title="مشاهده همه"></i></span>
      </template>
      <template slot="content">
        <div class="row">
          <div class="col-lg-4 col-6">
            <div class="row">
              <div class="col-12">
                <b-form-group v-slot="{ ariaDescribedby }">
                  <b-form-radio-group id="btn-radios-3" @change="SelectDate" v-model="selected" :options="['ماه جاری', 'امسال', 'همه']" :aria-describedby="ariaDescribedby" name="radio-btn-stacked" buttons stacked></b-form-radio-group>
                </b-form-group>
              </div>
              <div class="col-12 pt-4">
                <div class="w-100">
                  <span class="text-success" style="font-size: 0.6rem"
                    >میانگین پاسخ اول:
                    <h6>{{ averageTime == null ? 0 : averageTime }}</h6>
                    <span class="text-secondary" style="font-size: x-small">دقیقه</span></span
                  >
                </div>
              </div>
            </div>
          </div>

          <!-- <div class="col-lg-10 text-center">
            <highcharts class="hc" :options="HighchartOptions" ref="chart"></highcharts>
          </div> -->
          <div class="col-lg-8 text-center">
            <div v-if="statistics.length < 1" class="w-100">
              <h5>در این بازه تیکتی ثبت نشده است</h5>
            </div>
            <apexchart v-if="render" height="350" :options="ApexChartOptions" :series="ApexChartOptions.series"></apexchart>
          </div>
        </div>
      </template>
    </Card>
  </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'
export default {
  data() {
    return {
      render: true,
      selected: 'ماه جاری',
      averageTime: 0,
      statistics: [],
      HighchartOptions: {
        chart: {
          type: 'pie',
        },
        series: [
          {
            name: 'Brands',
            colorByPoint: true,
            data: [],
          },
        ],

        title: {
          text: 'وضعیت تیکتها',
        },
      },
      ApexChartOptions: {
        chart: {
          type: 'donut',
        },
        dataLabels: {
          enabled: false,
        },
        colors: ['#fd397a', '#5578eb', '#21AE89', '#5CB0FF', '#FDA700', '#11e345', '#78eb8d', '#f56905'],
        series: [],
        labels: [],
        stroke: {
          show: false,
        },
      },
    }
  },
  components: { Card, Card },
  methods: {
    AllTicket() {
      this.$router.push({ name: 'Tickets' })
    },
    SelectDate() {
      if (this.selected == 'ماه جاری') var selector = 2
      if (this.selected == 'امسال') var selector = 3
      else if (this.selected == 'همه') var selector = 4
      this.getData(selector)
    },
    getData(selector) {
      var DataAxios = { Method: 'POST', Action: 'Ticket/MyStatistics', ArryfildValue: { dateId: selector, tblUserId: this.$session.get('UserInfo').tblUserId } }
      //console.warn(DataAxios.ArryfildValue)
      this.$PostData(DataAxios)
        .then((resutl) => {
          this.averageTime = resutl.ticketAveragetime[0].averageTime
          this.statistics = resutl.todayTicketCount
        })
        .finally(() => {
          this.render = false
          if (this.statistics.length > 0) {
            this.HighchartOptions.series[0].data = []
            this.ApexChartOptions.series = []
            this.ApexChartOptions.labels = []
            this.statistics.forEach((element) => {
              // this.HighchartOptions.series[0].data.push({ name: element.nameCombo, y: element.countTicket })
              this.ApexChartOptions.labels.push(element.nameCombo)
              this.ApexChartOptions.series.push(element.countTicket)
              this.$nextTick(() => {
                this.render = true
                this.render = true
              })
            })
          }
        })
    },
  },
  created() {
    this.getData(2)
  },
}
</script>
<style>
#btn-radios-3 .btn-secondary {
  background: var(--sidebar-action-bg) !important;
}
#btn-radios-3 span {
  color: var(--sidebar-color-item) !important;
}
</style>
